import { authService } from '../../services/auth';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { useLayout } from '../../contexts/LayoutContext';
import { useTheme } from '../../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import { LogOut, Globe, Menu, Sun, Moon } from 'lucide-react';
import NotificationBell from '../NotificationBell';

export default function Header() {
  const isConnected = authService.isQuickBooksConnected();
  const { user, logout } = useAuth();
  const { language, toggleLanguage } = useLanguage();
  const { isDesktopSidebarOpen, toggleDesktopSidebar } = useLayout();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // V17.37: Dark mode support
  return (
    <header className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-3">
            {/* V17.34: Hamburger menu to toggle sidebar - native mobile app feel */}
            <button
              onClick={toggleDesktopSidebar}
              className="p-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
              title={isDesktopSidebarOpen ? (language === 'lo' ? 'ເຊື່ອງເມນູ' : 'Hide menu') : (language === 'lo' ? 'ສະແດງເມນູ' : 'Show menu')}
            >
              <Menu className="h-6 w-6" />
            </button>
            <h1 className="text-xl font-bold text-gray-900 dark:text-white">
              VTW Integration Hub
            </h1>
          </div>

          <div className="flex items-center space-x-4">
            {/* V17.37: Dark Mode Toggle Button */}
            <button
              onClick={toggleTheme}
              className="p-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
              title={
                theme === 'dark'
                  ? language === 'lo' ? 'ປ່ຽນເປັນໂໝດສະຫວ່າງ' : 'Switch to Light Mode'
                  : language === 'lo' ? 'ປ່ຽນເປັນໂໝດມືດ' : 'Switch to Dark Mode'
              }
            >
              {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </button>

            {/* V17.28.FIX: Language Toggle Button */}
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition-colors"
              title={language === 'lo' ? 'Switch to English' : 'ປ່ຽນເປັນພາສາລາວ'}
            >
              <Globe className="h-4 w-4" />
              <span className="font-semibold">{language === 'lo' ? 'LA' : 'EN'}</span>
            </button>

            {/* QuickBooks Connection Status Indicator (Read-only) */}
            {isConnected && (
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-sm text-gray-600 dark:text-gray-400">QuickBooks Connected</span>
              </div>
            )}

            {/* V17.5: Notification Bell */}
            {user && <NotificationBell />}

            {user && (
              <div className="flex items-center space-x-3 border-l border-gray-200 dark:border-gray-700 pl-4">
                <div className="text-right">
                  <p className="text-sm font-medium text-gray-900 dark:text-white">{user.full_name}</p>
                  {/* V17.539 (2C): the role control moved to the sidebar's top slot. */}
                </div>
                <button
                  onClick={handleLogout}
                  className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md"
                  title="Logout"
                >
                  <LogOut className="h-5 w-5" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
